var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tips",style:(_vm.style)},[_c('b',[_vm._t("default")],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.showClose)?_c('b-link',{staticClass:"small",on:{"click":_vm.close}},[_vm._v("我知道啦")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }